/* unplugin-vue-components disabled */import script from "./message-group-system.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-group-system.vue?vue&type=script&lang=ts&setup=true"

import "./message-group-system.vue?vue&type=style&index=0&id=375d9ca0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375d9ca0"]])

export default __exports__